module.exports = __webpack_public_path__ + "fonts/Raleway-Bold.21c82294.ttf";